import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, LastUsedKey, LastUsedSettingsType, LocalService, PageKey, Status, StatusWithId, TriggeredEvent, UserInfo } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { CreateAccountComponent } from '../../popups/create-account/create-account.component';
import { EditAdditionalDetailsComponent } from '../../popups/edit-additional-details/edit-additional-details.component';
import { EditSystemInfoComponent } from '../../popups/edit-system-info/edit-system-info.component';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
  wrapper: UserInfo; userId: string = ''; ctryCode: string = ''; maxBodyHeight = 0; billingMode = '';
  lstSectionConfigKeys: string[] = ["user_info", "create_account", "local_locations", 'barcode']; isAllowedForItem: StatusWithId;
  isOpenEditAccount = false;

  constructor(private languageManagementService: LanguageManagementService, private cdr: ChangeDetectorRef, public localService: LocalService, private profileManagementService: ProfileManagementService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.configurationManagementService.ensurePageActions(PageKey.User);
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      if (this.isAllowedForItem && this.isAllowedForItem.status == Status.Success) {
        this.onLoad();
      } else {
        this.profileManagementService.isAllowedForItem(this.userId).subscribe(result => {
          this.isAllowedForItem = result;
          if (this.isAllowedForItem.status == Status.Success) {
            this.onLoad();
          }
        });
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.profileManagementService.getUserInfo(this.userId, this.ctryCode).subscribe(result => {
      this.wrapper = result;
      this.billingMode = this.wrapper.systemInfo.v9 != '' ? this.wrapper.systemInfo.v9 : this.wrapper.billingMode[0].key;
    });
  }

  onRoute(index) {
    switch (index) {
      case 1: {
        this.router.navigate(['/sellers' + this.localService.basicParamsString]);
      } break;
      case 2: {
        this.router.navigate(['/relationships' + this.localService.basicParamsString, 0]);
      } break;
      case 3: {
        this.router.navigate(['/notifications' + this.localService.basicParamsString, 0]);
      } break;
      case 4: {
        this.router.navigate(['/my-bills' + this.localService.basicParamsString]);
      } break;
      case 5: {
        this.router.navigate(['/payments' + this.localService.basicParamsString, 0]);
      } break;
      case 6: {
        this.router.navigate(['/my-access' + this.localService.basicParamsString]);
      } break;
    }
  }

  onCloseEditAccount(result) {
    if (result && result.event == TriggeredEvent.Ok) {
      this.onLoad();
    }
  }

  onEdit(index) {
    switch (index) {
      case 1: {
        this.isOpenEditAccount = true;
      } break;
      case 2: {
        const modalRef = this.modalService.open(EditAdditionalDetailsComponent);
        modalRef.componentInstance.id = this.userId;
        modalRef.componentInstance.ctryCode = this.ctryCode;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok || result.event == TriggeredEvent.Close) {
            this.onLoad();
          }
        });
      } break;
      case 3: {
        const modalRef = this.modalService.open(EditSystemInfoComponent);
        modalRef.componentInstance.id = this.userId;
        modalRef.componentInstance.ctryCode = this.ctryCode;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.onLoad();
          }
        });
      } break;
      case 4: {
        this.localService.onFocusNextInput('btn_change_language', FocusInputType.Button, true);
      } break;
    }
  }
}
